// Centralized auth storage. When `remember = true` the token persists across
// browser sessions (localStorage). Otherwise it dies with the tab (sessionStorage).
// Reads check both stores so a previously-remembered session is still honored.

const TOKEN_KEY = "hush_token";
const USER_KEY = "hush_user";
const PERSIST_KEY = "hush_persist"; // "1" means remember-me is active

export const tokenStore = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
  },
  getUser() {
    const raw = localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  },
  setSession(token, user, remember) {
    // Clean both sides before writing so we don't leave stale copies behind.
    this.clear();
    const store = remember ? localStorage : sessionStorage;
    store.setItem(TOKEN_KEY, token);
    store.setItem(USER_KEY, JSON.stringify(user));
    if (remember) localStorage.setItem(PERSIST_KEY, "1");
  },
  updateUser(user) {
    const remember = localStorage.getItem(PERSIST_KEY) === "1";
    const store = remember ? localStorage : sessionStorage;
    store.setItem(USER_KEY, JSON.stringify(user));
  },
  clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(PERSIST_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  },
};
